<template>
  <div id="lContent">
    <div id="conList">
      <div id="wTable">
        <div id="tab1">文物保护</div>
        <div id="tab2">时间</div>
      </div>
      <router-link id="oneCon" v-for="(item, index) in tableData" :key="index" tag="div" :to="{path:'/academic/wprotectDetials', query:{id:item.id}}">
        <div id="navdht"><img src="../../assets/img/navdh.png"></div>
        <div>
          <div class="text">{{ item.title }}</div>
          <div><span>{{ item.starttime }}</span></div>
        </div>
      </router-link>
    </div>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
      :page-sizes="[10]" :page-size="10" layout="total, sizes, prev, pager, next, jumper" :total="pageTotal.total"
      style="margin: 2.5rem;text-align:right">
    </el-pagination>
  </div>
</template>

<script>
  import moment from 'moment'
  export default {
    data() {
      return {
        loading: false,
        tableData: [],
        pageTotal: [],
        currentPage: 1,
        pageSize: 10,
        pageNum: 1,
        arrData: []
      }
    },
    mounted() {
      this.handleSearch()
    },
    methods: {
      handleSizeChange(val) {
        this.pageSize = val;
      },
      handleCurrentChange(val) {
        this.pageNum = val;
        this.arrData = [];
        this.search();
      },
      handleSearch() {
        let eWidth = document.body.clientWidth;
        document.getElementById("conList").style.width = eWidth * 0.9 + "px";
        document.getElementById("wTable").style.width = eWidth * 0.9 + "px";
        this.search();
      },
      // 查询列表
      search: function() {
        let that = this;
        let url = this.HOST + '/api/v1/protection/protection?pageNumber=' + this.pageNum + '&pageSize=' + this.pageSize +
          '';
        this.loading = true;
        this.$axios.get(url).then(function(result) {
          let cData = result.data;
          that.pageTotal = cData.data;
          that.currentPage = that.pageTotal.pageNum;
          that.tableData = cData.data.list;
          for (let k = 0; k < that.tableData.length; k++) {
            for (let i = 0; i < that.tableData.length; i++) {
              let betime = parseInt(that.tableData[i].starttime);
              that.tableData[i].starttimeStr = moment(betime).format("YYYY-MM-DD");
            }
            if (that.tableData[k].title.length > 40) {
              that.tableData[k].title = (that.tableData[k].title).substring(0, 40) + "...";
            } else {
              that.tableData[k].title = that.tableData[k].title;
            };
          }
        }).catch(function(error) {
          console.log(err);
        })
      }
    }
  }
</script>

<style scoped>
  #wTable {
    height: 60px;
    position: relative;
    background: #DEDEDE;
    margin-top: 25px;
  }

  #tab1 {
    position: absolute;
    line-height: 30px;
    font-size: 1.3em;
    top: 15px;
    left: 50px;
    font-weight: 500;
  }

  #tab2 {
    position: absolute;
    line-height: 30px;
    font-size: 1.3em;
    top: 15px;
    right: 100px;
    font-weight: 500;
  }

  #navdht {
    position: absolute;
    width: 20px;
    height: 20px;
    top: 20px;
    left: 4.4%;
    cursor: pointer;
  }

  #navdht>img {
    width: 100%;
    height: 100%;
  }

  #oneCon {
    height: 60px;
    border-bottom: 1px solid #e5e5e5;
    position: relative;
  }

  #oneCon>div>div:nth-child(1) {
    position: absolute;
    line-height: 30px;
    font-size: 1em;
    top: 15px;
    left: 7%;
  }

  #oneCon>div>div:nth-child(2) {
    position: absolute;
    line-height: 30px;
    font-size: 1em;
    top: 15px;
    right: 4.2%;
    cursor: pointer;
  }

  #oneCon>div>.text {
    cursor: pointer;
  }

  #oneCon>div>.text:hover,
  #oneCon>div>div:nth-child(2):hover {
    color: #FF2222;
  }
</style>



// WEBPACK FOOTER //
// src/pages/academic/wprotect.vue